import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface MenuItemDto {
  menuId: number;
  menuName: string;
  menuDesc: string;
  isActive: boolean;
}

export function useMenuItems() {
  return useQuery({
    queryKey: ['menus'],
    queryFn: () => apiClient.get<MenuItemDto[]>('/api/menus'),
  });
}
